export default {
  title: 'Päivitä toimitusaika',
  labels: {
    dropoff_time: 'Toimitusaika',
    confirmed: 'Vahvistettu aika:',
    new_time: 'Uusi aika:',
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    success: 'Toimitusaika päivitettiin onnistuneesti',
    failed_to_save: 'Muutosten tallentaminen epäonnistui',
  },
  alerts: {
    dropoff_time_info: 'Sekä nykyinen että uusi aika ovat ravintolan {{restaurantName}} aikavyöhykkeellä {{timezone}}',
  },
};
